// extracted by mini-css-extract-plugin
var _1 = "mwbz03f3l8R_xfIND3Fz";
export { _1 as "root" }
